<template>
    <div class="tab-pane active">
        <app-button v-if="$store.getters.canEditSettings" native-type="button" type="success" class="float-right" @click="$modal.show('create_pricelist')">
            {{ $t('Create') }}
        </app-button>
        <div class="clearfix"></div>
        <table class="table table-striped table-sm">
            <thead>
                <tr>
                    <th>#</th>
                    <th>{{ $t('Name') }}</th>
                    <th>{{ $t('Period') }}</th>
                    <th>{{ $t('Active') }}</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(pricelist, i) in pricelists" :key="i">
                    <td>{{ i + 1 }}</td>
                    <td>{{ pricelist.name[locale] }}</td>
                    <td>{{ validityPeriod(pricelist) }}</td>
                    <td>
                        <div class="custom-control custom-switch">
                            <input
                                v-if="$store.getters.canEditSettings"
                                type="checkbox"
                                class="custom-control-input"
                                :id="`active_${i}`"
                                :checked="pricelist.active || ''"
                                @change="toggleActive(pricelist.id)"/>
                            <label class="custom-control-label" :for="`active_${i}`" />
                        </div>
                    </td>
                    <td class="p-0">
                        <div class="text-right">
                            <app-button
                                v-if="$store.getters.canEditSettings"
                                native-type="button"
                                @click="$modal.show('update_pricelist', { pricelist })"
                                small>
                                {{ $t('Edit') }}
                            </app-button>
                            <app-button v-if="$store.getters.canDeleteSettings" native-type="button" type="danger" @click="destroy(pricelist.id)" small>
                                {{ $t('Delete') }}
                            </app-button>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
        <create-modal @setPricelist="setPricelist" />
        <update-modal @setPricelist="setPricelist" />
    </div>
</template>

<script>
import PricelistService from '@services/pricelist.service';
import CreateModal from './modals/Create';
import UpdateModal from './modals/Update';
import { mapGetters } from 'vuex';
import { validityPeriod } from '@services/helper.service';
import Vue from 'vue';

export default {
    data() {
        return {
            pricelists: []
        };
    },
    computed: {
        ...mapGetters(['locale'])
    },
    methods: {
        validityPeriod(pricelist) {
            return validityPeriod(pricelist);
        },
        getPricelists() {
            PricelistService.pricelists().then(res => (this.pricelists = res));
        },
        setPricelist(pricelist) {
            const index = this.pricelists.findIndex(pl => pl.id === pricelist.id);
            if (index !== -1) {
                Vue.set(this.pricelists, index, pricelist);
            } else {
                this.pricelists.push(pricelist);
            }
        },
        toggleActive(pricelistId) {
            PricelistService.toggleActive(pricelistId).then(res => {
                const pl = this.pricelists.find(pl => pl.id === pricelistId);
                pl.active = !pl.active;
            });
        },
        destroy(pricelistId) {
            if (!window.confirm(`${this.$t('Delete')}?`)) {
                return false;
            }
            PricelistService.destroy(pricelistId).then(res => {
                const index = this.pricelists.findIndex(pl => pl.id === pricelistId);
                this.pricelists.splice(index, 1);
                this.$toastr.s(this.$t('Deleted'));
            });
        }
    },
    components: {
        CreateModal,
        UpdateModal
    },
    created() {
        this.getPricelists();
    },
    metaInfo() {
        return {
            title: this.$t('Price lists')
        };
    }
};
</script>
